// synthetic-arabic: reviewed-no-scripture — ordinary product interface wording invented for this
// application; no Qur'an, hadith, translation or religious quotation.
import { messages, type Language } from './i18n.js';

/**
 * The words shown while a stage is genuinely running. The server reports the stage only at the
 * moment that work actually happens — these lines never advance on a timer and never pretend.
 */
export const STAGE_LINES = messages({
  ar: {
    understanding: 'أقرأ ما كتبته…',
    screening: 'أطمئن أن كل شيء على ما يرام…',
    thinking: 'أفكر في أفضل طريقة للرد…',
    rewriting: 'أعيد صياغة ردي…',
    sources: 'أبحث في المصادر الموثوقة…',
    selecting: 'أختار الأنسب من المصادر المعتمدة…',
    judging: 'أتأكد أن المصدر يناسب حالتك…',
    verifying: 'أتحقق من المصدر قبل أن أعرضه…',
    checking: 'أراجع الرد قبل أن يصلك…',
    // The client's own stage, for when it is re-sending after an outage rather than waiting on work.
    retrying: 'تعذّر الاتصال، أعيد المحاولة…',
  },
  en: {
    understanding: 'Reading what you wrote…',
    screening: 'Making sure everything is alright…',
    thinking: 'Thinking about how best to answer…',
    rewriting: 'Rewriting my reply…',
    sources: 'Looking through the verified sources…',
    selecting: 'Choosing the one that fits…',
    judging: 'Checking that the source suits your situation…',
    verifying: 'Verifying the source before showing it…',
    checking: 'Going over the reply before it reaches you…',
    retrying: 'The connection failed; trying again…',
  },
});

export function stageLine(stage: string | null, language: Language = 'ar'): string {
  const lines: Readonly<Record<string, string>> = STAGE_LINES[language];
  return lines[stage ?? 'understanding'] ?? lines['understanding'] ?? '';
}
